import styles from './ScenarioNavBar.module.scss';
import { SCENARIO_LIST } from 'constants/components';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import infoIcon from 'assets/images/info-icon.svg';
import darkInfoIcon from 'assets/images/dark-info-icon.svg';

const ScenarioNavBar = ({ isRibbonVisible, navigateTo }) => {
    const { pathname } = useLocation();
    const [navList, setNavList] = useState(SCENARIO_LIST);
    const [selectedNav, setSelectedNav] = useState();
    const [hoveredIcon, setHoveredIcon] = useState(null);

    useEffect(() => {
        setCurrentScenarioSelected();

        if (!isScenarioPage()) {
            resetScenarioNavList();
        }

        return () => {};
    }, [pathname]);

    const onMouseOver = (nav, isEntered) => {
        setSelectedNav(isEntered ? nav : null);
    };

    const onScenarioClick = (nav) => {
        navigateTo(pathname, nav.path);
    };

    const setCurrentScenarioSelected = () => {
        const index = navList.findIndex((s) => s.path === pathname);
        if (index > -1) {
            navList[index].isSelected = true;
            setNavList(
                navList.map((n, i) => ({
                    ...n,
                    isSelected: i === index
                }))
            );
        }
    };

    const calculateSelectedCssClass = (nav) => {
        if (nav.isSelected === true) {
            return styles.selected;
        } else if (nav.isSelected === false) {
            return styles.notSelected;
        } else {
            return '';
        }
    };

    const isScenarioPage = () => {
        return navList.map((n) => n.path).includes(pathname);
    };

    const resetScenarioNavList = () => {
        setNavList(
            navList.map((nav) => ({
                ...nav,
                isSelected: undefined
            }))
        );
    };

    const getScenarioNavBarWidth = () => {
        const elements = document.getElementsByClassName(styles.scenarioNav);
        if (elements.length > 0) {
            let widths = 0;
            for (let i = 0; i < elements.length; i++) {
                widths += elements[i].clientWidth;
            }

            return widths;
        }

        return 0;
    };

    return (
        <div
            id="ScenarioNavBar"
            className={styles.wrapper}
            style={{ height: isRibbonVisible ? '70px' : '0px' }}
        >
            <div className={styles.innerWrapper}>
                {navList.map((nav, i) => (
                    <div
                        key={`sn-${i}`}
                        className={`${styles.scenarioNav} ${
                            selectedNav &&
                            selectedNav.id !== nav.id &&
                            selectedNav !== null
                                ? styles.disabled
                                : ''
                        } ${calculateSelectedCssClass(nav)}`}
                        onMouseEnter={() => onMouseOver(nav, true)}
                        onMouseLeave={() => onMouseOver(nav, false)}
                        onClick={() => onScenarioClick(nav)}
                    >
                        <div className={styles.navTitle}>
                            {nav.title}
                            <img
                                onMouseOver={() => setHoveredIcon(nav.id)}
                                onMouseOut={() => setHoveredIcon(null)}
                                src={
                                    hoveredIcon === nav.id
                                        ? darkInfoIcon
                                        : infoIcon
                                }
                                alt={''}
                            />
                        </div>
                        <div
                            className={
                                i === navList.length - 1
                                    ? `${styles.container} ${styles.lastContainer}`
                                    : styles.container
                            }
                            style={
                                i === navList.length - 1 &&
                                window.innerWidth <= 1460
                                    ? {
                                          visibility:
                                              hoveredIcon === nav.id
                                                  ? 'visible'
                                                  : 'hidden',
                                          left:
                                              window.innerWidth -
                                              getScenarioNavBarWidth() -
                                              100,
                                          marginLeft: 0
                                      }
                                    : {
                                          visibility:
                                              hoveredIcon === nav.id
                                                  ? 'visible'
                                                  : 'hidden',
                                          marginLeft: 70
                                      }
                            }
                        >
                            <div>
                                <div>
                                    <p className={styles.infoTitle}>
                                        Description
                                    </p>
                                    <p className={styles.infoText}>
                                        {nav.info.description}
                                    </p>
                                </div>
                                <div>
                                    <p className={styles.infoTitle}>
                                        Critical ratio
                                    </p>
                                    <p className={styles.infoText}>
                                        {nav.info.criticalRatio}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className={styles.navText}>{nav.description}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

ScenarioNavBar.propTypes = {
    isRibbonVisible: PropTypes.bool,
    navigateTo: PropTypes.func
};
export default ScenarioNavBar;
